import { render, staticRenderFns } from "./OAuthCallback.vue?vue&type=template&id=546d741a"
import script from "./OAuthCallback.vue?vue&type=script&lang=ts"
export * from "./OAuthCallback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports